import clsx from "clsx";
import { DiffItem as DiffItemProps } from "./index.types";
import "./index.css";

export function DiffItem({
  className,
  placeholder,
  title,
  children,
}: DiffItemProps) {
  return (
    <div
      className={clsx(
        "diff-item",
        { "diff-item--placeholder": placeholder },
        className
      )}
    >
      <div
        className={clsx("diff-item__check", {
          "diff-item__check--ph": placeholder,
        })}
      >
        ✓
      </div>
      <div>
        <strong>{title}</strong>
        <p>{children}</p>
      </div>
    </div>
  );
}

export default DiffItem;
